import { createContext, useCallback, useMemo, useState } from 'react'
import { searchAudio } from './helpers'

import { useSelector } from 'react-redux'
import { audioSelectors } from 'store/features/audio/selectors'
import { IUserAudio } from 'store/types/audio'
import { MUSIC_LIBRARY, MY_MUSIC } from '../content/data'

interface IAudioContentContext {
  musicSearchValue: string
  setMusicSearchValue: (value: string) => void
  isShowMusicSearchView: boolean
  isAudioSearchLoading: boolean
  setIsAudioSearchLoading: (value: boolean) => void
  searchedMusicList: IUserAudio[]
  musicActiveTabName: string
  setMusicActiveTabName: (value: string) => void
  goToMyMusic: () => void
}

export const AudioContentContext = createContext<IAudioContentContext>({
  musicSearchValue: '',
  setMusicSearchValue: () => {},
  isShowMusicSearchView: false,
  isAudioSearchLoading: false,
  setIsAudioSearchLoading: () => {},
  searchedMusicList: [],
  musicActiveTabName: MUSIC_LIBRARY,
  setMusicActiveTabName: () => {},
  goToMyMusic: () => {}
})

export const AudioContentProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [musicSearchValue, setMusicSearchValue] = useState('')
  const [isAudioSearchLoading, setIsAudioSearchLoading] = useState(false)
  const [musicActiveTabName, setMusicActiveTabName] = useState(MUSIC_LIBRARY)

  const libSoundsInOneList = useSelector(audioSelectors.libSoundsInOneList)
  const userSounds = useSelector(audioSelectors.userSounds)

  const searchedMusicList = useMemo(() => {
    return searchAudio(musicSearchValue, libSoundsInOneList, userSounds)
  }, [musicSearchValue, libSoundsInOneList, userSounds])

  const isShowMusicSearchView = !!musicSearchValue || isAudioSearchLoading

  const goToMyMusic = useCallback(() => {
    setMusicActiveTabName(MY_MUSIC)
    if (musicSearchValue) {
      setMusicSearchValue('')
    }
  }, [setMusicActiveTabName, musicSearchValue, setMusicSearchValue])

  return (
    <AudioContentContext.Provider
      value={{
        musicSearchValue,
        setMusicSearchValue,
        isShowMusicSearchView,
        isAudioSearchLoading,
        setIsAudioSearchLoading,
        searchedMusicList,
        musicActiveTabName,
        setMusicActiveTabName,
        goToMyMusic
      }}
    >
      {children}
    </AudioContentContext.Provider>
  )
}
